import { SendOrderUsecase, SendOrderUsecaseImp } from 'domain/usecases/send-order-usecase';
import { makeSendOrderHttpRepository } from '../repositories/http/orders-http-repository-factory';

export const makeCryptoSendOrderUsecase = (): SendOrderUsecase => {
  return new SendOrderUsecaseImp(makeSendOrderHttpRepository());
};
